import styled from 'styled-components';

const MainOfertaDiv = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  flex-direction: column;
`;

const NabDiv = styled.div`
  display: flex;
  flex-direction: column;
  background: #85be80;
  border: 7px solid #18665a;
  border-radius: 10px;
  padding: 5px;
  align-items: center;
  margin: 20px;
`;

const StyledH1 = styled.h1`
  border-bottom: 2px dashed grey;
  margin: 0 20px 0 20px;
`;

const OfertaHolder = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  margin: 20px;
`;

const OfertaDiv = styled.div`
  display: flex;
  flex-direction: column;
  background: #85be80;
  border-radius: 10px;
  padding: 5px;
  margin: 0 10px 0 10px;
  border: 4px dashed #18665a;
  box-shadow: 5px 5px 5px #000000a0;
`;

const OfertaP = styled.p`
  margin: 5px 0 5px 0;
`;

const InfoDiv = styled.div`
  display: flex;
  flex-direction: inherit;
  background: #f51836;
  align-items: center;
  border: 6px dashed #aa1416;
  border-radius: 10px;
`;

export const Oferta = (params) => {
  return (
    <MainOfertaDiv>
      <NabDiv>
        <p>
          <span style={{ fontWeight: 'bold' }}>Pamiętaj!!!</span>: Nabór trwa
          nieprzerwanie od czerwca 2019 roku.
        </p>
      </NabDiv>
      <StyledH1>Nasza Oferta:</StyledH1>
      <OfertaHolder>
        <OfertaDiv>
          <OfertaP style={{ fontWeight: 'bold' }}>Standard:</OfertaP>
          <OfertaP>Zapisy dzieci w wieku od 1-3 lat.</OfertaP>
          <OfertaP style={{ fontWeight: 'bold' }}>Od: 6:45 Do: 17:00</OfertaP>
          <OfertaP>
            Opłata rodzica -
            <span style={{ fontWeight: 'bold' }}>
              {' '}
              jednorazowe wpisowe 250zł{' '}
            </span>
            oraz <span style={{ fontWeight: 'bold' }}>800zł miesięcznie </span>+
            stawka dzienna za wyżywienie (odliczane w przypadku zgłoszonej
            nieobecności dziecka).
          </OfertaP>
          <OfertaP>
            W opłacie zawarte zajęcia z języka angielskiego, spotkania z
            logopedą, rytmika, zajęcia plastyczne.
          </OfertaP>
        </OfertaDiv>
        <InfoDiv>
          <p>
            Aby dowiedzieć się więcej prosimy o Kontakt. Znajdziesz inforamcjie
            o kontakcie do nas w zakładce{' '}
            <span style={{ fontWeight: 'bold' }}> Kontakt</span>
          </p>
        </InfoDiv>
      </OfertaHolder>
    </MainOfertaDiv>
  );
};
